
import { OptionSelect } from "@/presentation/models";
import { defineComponent } from "vue";

type ComponentData = {
  selected?: OptionSelect;
  validation_message?: string;
  show_options: boolean;
};

export default defineComponent({
  name: "SelectOption",
  data(): ComponentData {
    const options = this.$props.options as OptionSelect[];
    const selected = options?.find((op) => op.value == this.$props.modelValue);

    return {
      show_options: false,
      selected,
      validation_message: undefined,
    };
  },
  props: {
    modelValue: Number,
    name: String,
    label: String,
    empty_message: String,
    readonly: Boolean,
    manual_focus: Boolean,
    options: Array,
    required: Boolean,
  },
  emits: ["update:modelValue", "updateValidation"],
  methods: {
    setSelected(option: OptionSelect) {
      this.$emit("update:modelValue", option.value);
      this.selected = option;
      this.validate();
    },
    show() {
      this.show_options = true;
    },
    hide() {
      this.show_options = false;
      this.validate();
    },
    validate() {
      if (this.required && !this.selected)
        this.validation_message = "Seleção obrigatória";
      else this.validation_message = undefined;
      this.$emit(
        "updateValidation",
        this.name,
        !!this.selected || !this.required
      );
    },
  },
  watch: {
    modelValue(v: number) {
      const options = this.options as OptionSelect[];
      this.selected = options.find((op) => op.value == v);
      this.validate();
    },
  },
});
